/**
 * Fixture for the schedules widget — shape of list_schedules's structured
 * output (mcp/server.ts listSchedulesTool → scheduleViewWithMode rows).
 * Headlined by the 01:30 nightly sweep; one paused row for contrast.
 */
import { SCHEDULE_IDS, hoursAgo, minAgo } from "./seed";

export function schedulesFixture(): Record<string, unknown> {
  return {
    schedules: [
      {
        scheduleId: SCHEDULE_IDS.sweep,
        name: "Nightly inbox sweep",
        cron: "30 1 * * ? *",
        agentName: "email-triage",
        prompt:
          "Sweep the overnight inbox. Flag anything urgent, draft replies " +
          "for review, and file the rest.",
        enabled: true,
        timezone: "America/New_York",
        mode: "message",
        loopInterval: null,
        model: null,
        effort: null,
        alwaysRun: false,
        createdBy: null,
        createdAt: hoursAgo(26 * 24),
        lastFiredAt: minAgo(310), // this morning, 01:30
        lastJobId: "job-sweep-0041",
      },
      {
        scheduleId: SCHEDULE_IDS.health,
        name: "Health data sync",
        cron: "0 3 * * ? *",
        agentName: "health-sync",
        prompt:
          "Pull last night's sleep and recovery data, then update the " +
          "health log and weekly rollup.",
        enabled: true,
        timezone: "America/New_York",
        mode: "message",
        loopInterval: null,
        model: "haiku",
        effort: "low",
        alwaysRun: true,
        createdBy: null,
        createdAt: hoursAgo(19 * 24),
        lastFiredAt: minAgo(220), // this morning, 03:00
        lastJobId: "job-health-0040",
      },
      {
        scheduleId: SCHEDULE_IDS.brief,
        name: "Weekday morning brief",
        cron: "15 6 ? * MON-FRI *",
        agentName: "morning-brief",
        prompt:
          "Compile the morning brief: overnight runs, today's calendar, " +
          "and anything that needs a human.",
        enabled: false,
        timezone: "America/New_York",
        mode: "message",
        loopInterval: null,
        model: null,
        effort: "medium",
        alwaysRun: false,
        createdBy: null,
        createdAt: hoursAgo(12 * 24),
        lastFiredAt: hoursAgo(76), // last fired before it was paused
        lastJobId: null,
      },
    ],
  };
}
